import React, { useState, useCallback } from 'react';
import { useI18n } from '../i18n';
import Post from './Post';

const SavedPosts = ({ 
  bookmarkService, 
  bluesky, 
  isLoggedIn, 
  onLoginRequired, 
  onLike,
  onRepost
}) => {
  const { t } = useI18n();
  const [removedPosts, setRemovedPosts] = useState(new Set());
  const bookmarks = bookmarkService.getBookmarks()
    .filter(bookmark => !removedPosts.has(bookmark.post.post.cid));

  const handleBookmarkRemove = useCallback((postCid) => {
    if (bookmarkService.removeBookmark(postCid)) {
      setRemovedPosts(prev => new Set(prev).add(postCid));
    }
  }, [bookmarkService]);

  if (bookmarks.length === 0) {
    return (
      <div className="saved-posts-message">
        <span className="message-icon">📌</span>
        <h3>{t('feed.noSavedPosts')}</h3>
        <p>{t('feed.savePostsHint')}</p>
      </div>
    );
  }

  return (
    <div className="posts-container">
      {bookmarks.map(({ post, savedAt }) => (
        <Post
          key={`${post.post.cid}-${savedAt}`}
          post={post}
          onLike={onLike}
          onRepost={onRepost}
          onLoginRequired={onLoginRequired}
          isLoggedIn={isLoggedIn}
          bluesky={bluesky}
          bookmarkService={bookmarkService}
          onBookmarkRemove={handleBookmarkRemove}
          isSavedView={true}
        />
      ))}
    </div>
  );
};

export default SavedPosts;
